var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2509 9H3.74781",
    stroke: "#A1A1A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.2509L11.2509 8.99999L9 6.74905",
    stroke: "#A1A1A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96022 12.0012C3.28161 12.6579 3.70893 13.2572 4.22504 13.775C6.15633 15.7063 9.06084 16.284 11.5842 15.2388C14.1076 14.1936 15.7528 11.7313 15.7528 9.00003C15.7528 6.26877 14.1076 3.80645 11.5842 2.76125C9.06084 1.71604 6.15633 2.29379 4.22504 4.22508C3.70894 4.74287 3.28162 5.34211 2.96022 5.99875",
    stroke: "#A1A1A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSso);
export default __webpack_public_path__ + "static/media/arrowSSO.993ddafe5959778b0a5b69af89017541.svg";
export { ForwardRef as ReactComponent };